import React, { Component } from 'react';

import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import { getChartData, getDatasourceAndDates } from '../../../api';
import { largeSize, xlsxCustomExport } from '../utils/chartConfig';
import { isFullscreen } from '../utils/Utils';
import SelectDataset from '../SelectDataset';

require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/export-data')(Highcharts);

const IMG_URL = process.env.IMG_FULL_URL;

const xAxisColor = "#808080";
const euColor = "#003399";
const euColorLight = "#7f97ce";

class MentalRiskCharts extends Component {
    constructor(props) {
        super(props);
        const stateThis = this;

        let answers = [];
        let selectedType = this.props.selectedIndicator != undefined ? this.props.selectedIndicator :  this.props.chartType[0].type;
        
        if(selectedType != undefined){
            let chart = this.props.chartType.find((chart) => chart.type == selectedType);
            if(chart != undefined){
                answers = chart.sortByAnswer
            }
        }

        this.state = {
            selectedDataset: this.props.selectedDataset ? this.props.selectedDataset : undefined,
            selectedTypeChart: selectedType,
            //selectedSortBy: false,
            chartConfig: {
                title: {
                    text: props.fullCountryReport == true ? '' : window.innerWidth > 768 ? 
                        "<h2 class='title--card'>"+this.props.literals[`L${this.props.chartType[0].title}`]+"</h2>" 
                        : 
                        "<h2 class='title--card'>"+this.props.literals[`L${this.props.tabIndicator}`]+"</h2>",
                    //text: this.props.chartTitle[`L${this.props.chartType[0].title}`],
                    align: 'left',
					widthAdjust: -50,
					y:20,
					style: {
						zIndex: 1,
						lineHeight:36
					}
                },
				credits: {
					enabled: true,
					text: "",
					href: '',
					style: {
						cursor: 'arrow'
					},
					position: {
						x: this.props.chartType[0].type == 'ewcs' ? -270 : -130
					}
				},
                chart: {
                    height: window.innerWidth > 768 ? 450 : 770,
                    type: window.innerWidth > 768 ? 'column' : 'bar',
                    backgroundColor: '#F0F0F0',
                    events: {
                        render: function() {
                            let chart = this;
                            stateThis.showEurofoundImage(chart);
                        }
                    },
                },
				exporting: {
					// enabled: true,
                    enabled: this.props.exportingEnabled,
                    sourceHeight: 600,
					buttons: {
						contextButton: {
							menuItems: ["viewFullscreen", "printChart", "separator", "downloadPNG", "downloadJPEG", "downloadPDF", "downloadSVG", "separator", "downloadCSV", "downloadXLS"]							
						}
					},
                    sourceWidth: largeSize,
                    filename: this.props.literals[`L${this.props.chartType[0].title}`].replace(/ /g, '_'),
                    menuItemDefinitions: {
                        "downloadXLS": {
                            onclick: function() {
                                xlsxCustomExport('Category', this.series, this.title.textStr);
                            }
                        }
                    }
				},
				navigation: {
					buttonOptions: {
						theme: {
							fill: 'transparent',
							states: {
								hover: {
									fill: '#CCC'
								},
								select: {
									fill: 'transparent'
								}
							}
						},
						verticalAlign: 'top',
						y: 0
					}
				},
				legend:{
					reversed: true,
					//verticalAlign: 'bottom',
					symbolRadius: 0,
					//layout: 'vertical',
					itemMarginTop:4,
					itemMarginBottom:4,
					//width: 300,
					itemStyle: {
						fontFamily: 'OpenSans',
						fontWeight: 'normal',
						fontSize:'12px',
						textOverflow: "ellipsis",
						//width: 150
					}
				},
				tooltip: {					
					useHTML: true,
					opacity: 1,
					backgroundColor: "rgba(255, 255, 255, 1)",
					zIndex: 100,
					borderWidth:1,
					borderColor:"#529FA2",
					// followPointer: true,
					// followTouchMove: true,
					style: {
						zIndex: 100
					},
					formatter: function () {
                        let tooltipContent = '<ul class="tooltip-item">';
                        if (this.series.name != 'Value')
                        {
                            tooltipContent += '<li><strong>Anwser: </strong>'+ this.series.name +' </li>';
                        }

                        tooltipContent += '<li><strong>Country: </strong>'+ this.x  +' </li>' +
						'<li><strong class="tooltip-value up">Value: </strong> '+ this.y +'%</li>' +
						'</ul>';
						return tooltipContent;
					}
				},
                xAxis: {
                    lineWidth: 0,
                    max: this.props.yAxisMax,
                    plotLines: [
                        {
                            color: 'black',
                            width: '2',
                            value: 0.5,
                            zIndex:1
                        },
                        {
                            color: 'black',
                            width: '2',
                            value: 29.5,
                            zIndex:1
                        }
                    ],
                    labels: {
                        // staggerLines: 1,
                        style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',                            
                            fontSize: this.props.fullCountryReport ? '10px' : '12px',
                            color:xAxisColor
						}
                    }
                },
                yAxis: {
                    gridLineColor:'#FFF',
                    gridLineWidth:2,
                    title: {
                        text: ''
                    },
                    labels: {
						format: this.props.percentage === true ? '{value:,.0f} %' : `{value:,.0f} ${this.props.percentage}`,
						style: {
							fontFamily: 'OpenSans-bold',
							fontWeight: 'normal',
							fontSize:this.props.fullCountryReport ? '10px' : '12px'
						}
                    },
                    min: 0,
                    max: 100
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        borderWidth: 0,  
                        pointStart: 0,
                        groupPadding: this.props.fullCountryReport ? 0 : 0.2,
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        },
                        point: {
                            events: {
                                mouseOver: function () {
                                    let series = this.series.data;
                                    series.forEach((p) => {
                                        p.setState('hover')
                                    });
                                },
                                mouseOut: function () {
                                    let series = this.series.data;
                                    series.forEach((p) => {
                                        p.setState();
                                    })
                                }
                            }
                        }
                    },
                    bar: {
                        stacking: 'normal',
                        borderWidth: 0,
                        states: {
                            inactive: {
                                opacity: 1
                            }
                        }
                    }
                },
                series: []
            },
            isLoading: true,
            typeCharts: [],
            sortByAnswer: answers
        }
    }
    
    onChangeSelect = (e) => {
        this.setState({ selectedTypeChart: e.target.value });

        if(this.props.callbackSelectedSurvey != undefined){
            this.props.callbackSelectedSurvey(e.target.value);
        }        

        const serie = this.props.chartType.find((chart) => chart.type == e.target.value);
        if (window.innerWidth > 768 ) {
            this.setState({ 
                chartConfig: {
                    ...this.state.chartConfig, 
                    title: {
                        ...this.state.chartConfig.title, 
                        text: this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.literals[`L${serie.title}`]+"</h2>" 
                    },
                    exporting: {
                        ...this.state.chartConfig.exporting, 
                        filename: this.props.literals[`L${serie.title}`].replace(/ /g, '_')
                    }
                } 
            })
        }
    }

    showEurofoundImage = (mentalRiskChart) => {
        let showEurofound = this.props.selectedIndicator != undefined ? this.props.selectedIndicator : this.state.selectedTypeChart ;
        if (!mentalRiskChart.customImage)
        {
            mentalRiskChart.customImage = mentalRiskChart.renderer.image(
                `${IMG_URL}osh-barometer/img/EU-OSHA-en.png`,
                mentalRiskChart.chartWidth - 130,
                mentalRiskChart.chartHeight - 37,
                130,
                37
            ).add();
            mentalRiskChart.customImage.attr({
            class:'osha-logo'
        });
        }
        else
        {
            mentalRiskChart.customImage.attr({
                x: mentalRiskChart.chartWidth - 130,
                y: mentalRiskChart.chartHeight - 37
            });
        }
        
        if(showEurofound == 'ewcs'){
            if (!mentalRiskChart.customImageEurofound)
            {
                mentalRiskChart.customImageEurofound = mentalRiskChart.renderer.image(
                    `${IMG_URL}osh-barometer/img/eurofound-logo.png`,
                    mentalRiskChart.chartWidth - 270,
                    mentalRiskChart.chartHeight - 37,
                    130,
                    37
                ).add();
                mentalRiskChart.customImageEurofound.attr({
                class:'eurofound-logo'
            });
            }
            else
            {
                mentalRiskChart.customImageEurofound.attr({
                    x: mentalRiskChart.chartWidth - 270,
                    y: mentalRiskChart.chartHeight - 37
                });
            }
        }

        if (mentalRiskChart.fullscreen.isOpen) {
            mentalRiskChart.customImage.css({
                display: 'block'
            });
            if(showEurofound == 'ewcs'){
                mentalRiskChart.customImageEurofound.css({
                    display: 'block'
                });
            }
            mentalRiskChart.container.className = 'highcharts-container full-screen';
        }
        else
        {
            mentalRiskChart.customImage.css({
                display: ''
            });
            if(showEurofound == 'ewcs'){
                mentalRiskChart.customImageEurofound.css({
                    display: ''
                });
            }
            mentalRiskChart.container.className = 'highcharts-container';
        }
    }
    
    getLoadData = (chartType) => {
        let categories = [];
        let auxSeries = [];
        let series = [];

        let chart = [];
        
        if (chartType.length > 1) {
            chart = chartType.find((chart) => chart.type == this.props.selectedIndicator);
        } else {
            chart = chartType[0];
            this.setState({ selectedTypeChart: null });
        }

        if(this.props.callbackLegend != undefined){
            this.props.callbackLegend(chart.legend);
        }

        let dataset = this.state.selectedDataset;
        if (this.props.selectedDataset != undefined)
        {
            dataset = this.props.selectedDataset != "null" ? this.props.selectedDataset : null;
        }

        // Load the texts for the credits in the image when maximising or exporting the chart
        this.getCredits(chart.chart, dataset);

        this.setState({ ...this.state, chartConfig: {...this.state.chartConfig, series: [], credits: {...this.state.chartConfig.credits, position: { x: chart.type == 'ewcs' ? -270 : -130 } } } , isLoading: true });

        try {
            let requestFilter = {
                chart: chart.chart,
                indicator: chart.chartIndicator,
                sector: chart.sector,
                answers: chart.answers,
                dataset,
                sortAnswer: this.props.selectedSortBy == true ? this.state.sortByAnswer : undefined
            }

            getChartData(requestFilter)
                .then((data) => {
                    if(data.resultset.length > 0){  

                        data.resultset.forEach(element => {
                            if (categories.indexOf(element.country) == -1) {
                                categories.push(element.country)
                            }
        
                            let split = element.split;
                            if (!(split in auxSeries)) {
                                auxSeries[split] = []
                            }
                            
                            auxSeries[split].push({ name: element.country, y: element.value });
                        });

                        let customEUColor = true;
                        if (Object.keys(auxSeries).length > 2)
                        {
                            customEUColor = false;
                        }
                        for (let serie in auxSeries) {
                            if (customEUColor == true)
                            {
                                if (serie == 'Yes' || serie == 'Once or more' || serie == 'Mean' || serie == 'At least 1/4 of the time' || serie == 'Value') {
                                    let euValueSerie1 = {...auxSeries[serie][0], color: euColor}
                                    auxSeries[serie][0] = euValueSerie1
                                }
                                if (serie == 'No' || serie == 'Never' || serie == 'Less than 1/4 of the time' ) {
                                    let euValueSerie2 = {...auxSeries[serie][0], color: euColorLight}
                                    auxSeries[serie][0] = euValueSerie2
                                }
                            }
                            series.push({ name: serie, data: auxSeries[serie] });
                        }

                        if(this.props.country)
                        {
                            const selectedCountryColors = ['#F6A400','#F3C564'];
                            // Change the colour for the current country
                            for (let i = 0; i < series[0].data.length; i++)
                            {   
                                if (series[0].data[i].name.includes("("+this.props.country+")"))
                                {
                                    series[0].data[i] = {...series[0].data[i], color: selectedCountryColors[0]}
                                    if (series[1])
                                    {
                                        series[1].data[i] = {...series[1].data[i], color: selectedCountryColors[1]}
                                    }                                
                                }
                                else if (series[0].data[i].name == 'EU27' || series[0].data[i].name == 'EU28')
                                {
                                    series[0].data[i] = {...series[0].data[i], color: euColor}
                                    if (series[1])
                                    {
                                        series[1].data[i] = {...series[1].data[i], color: euColorLight}
                                    }                                
                                }
                                else
                                {
                                    series[0].data[i] = {...series[0].data[i], color: this.props.colors[this.props.colors.length - 1]}
                                    if (series[1])
                                    {
                                        series[1].data[i] = {...series[1].data[i], color: this.props.colors[this.props.colors.length - 2]}
                                    }                                
                                }
                            }
                        }

                        const reversedArray = [...series].reverse();

                        let plotLines = [{width: '2', color: 'black', value: 0.5, zIndex:1}, {width: '2', color: 'black', value: 27.5, zIndex:1}];
                        if (this.props.selectedSortBy == true || this.props.selectedIndicator == 'flash')
                        {
                            plotLines = [{width: '2', color: 'black', value: 0.5, zIndex:1}];
                        }

                        let colors = this.props.colors;
                        let legendEnabled = true;
                        
                        if (series.length != colors.length)
                        {
                            if (series.length == 1)
                            {
                                colors = colors.slice(4,5);
                                legendEnabled = false;
                            }
                            else if (series.length == 2)
                            {
                                colors = colors.length > 3 ? colors.slice(3,5) : colors.slice(2,4);
                            }
                            else if (series.length == 3)
                            {
                                if (colors.length > 3)
                                {
                                    colors = colors.slice(2,5);
                                }
                            }
                            else if (series.length == 4)
                            {
                                colors = colors.slice(1);
                            }
                        }

                        this.setState({ chartConfig: {...this.state.chartConfig, series: reversedArray, colors, legend: {...this.state.chartConfig.legend, enabled:legendEnabled}, xAxis: {...this.state.chartConfig.xAxis, plotLines, categories} }})

                        if (window.innerWidth > 768 ) {
                            this.setState({ 
                                chartConfig: {
                                    ...this.state.chartConfig, 
                                    title: {
                                        ...this.state.chartConfig.title, 
                                        text: this.props.fullCountryReport == true ? '' : "<h2 class='title--card'>"+this.props.literals[`L${chart.title}`]+"</h2>" 
                                    },
                                    exporting: {
                                        ...this.state.chartConfig.exporting, 
                                        filename: this.props.literals[`L${chart.title}`].replace(/ /g, '_')
                                    }
                                } 
                            })
                        }
                    }
                });
        } catch (error) {
            console.log('error', error)    
        } finally {
            setTimeout(() => {
                this.setState({ ...this.state, isLoading: false });
            }, 50);
        }
    }

    getCredits = (chart, dataset) => {
        getDatasourceAndDates(chart, dataset).then((res)=>{
            let text = res;
            this.setState({
                chartConfig: {...this.state.chartConfig, credits: {...this.state.chartConfig.credits, text}}
            })
        })		
    }

    updateDimension = () => {
        const width = window.innerWidth;
        const height = window.innerHeight;

        let chart;
        let chartTitleLiteral = '';

        if (this.props.chartType.length > 1) {
            chart = this.props.chartType.find((chart) => chart.type == this.state.selectedTypeChart);
            if(chart){
                chartTitleLiteral = chart.title;
            }else{
                chartTitleLiteral = this.props.chartType[0].title;
            }
        }else{
            chartTitleLiteral = this.props.chartType[0].title;
        }

        if (width > 767) {
            const chart = this.props.chartType.find((chart) => chart.type == this.props.selectedIndicator);
            const title = chart != undefined ? this.props.literals[`L${chart.title}`] : this.props.literals[`L${chartTitleLiteral}`];
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height},
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: this.props.fullCountryReport == true? 250 : 450, type: 'column'},
                        title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : this.props.reportTitle != undefined ? "<h2 class='title--card'>"+this.props.reportTitle+"</h2>" : `<h2 class='title--card'>${title}</h2>`}
                    }
                });
            }
        }

        let tabTitle = this.props.literals[`L${this.props.tabIndicator}`];

        if (width < 768) {
            if (isFullscreen()) {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: height},
                    }
                });
            } else {
                this.setState({
                    chartConfig: {
                        ...this.state.chartConfig,
                        chart: {...this.state.chartConfig.chart, height: 785, type: 'bar'},
                        title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : `<h2 class='title--card'>${tabTitle}</h2>`}
                    }
                });
            }
        }

        if (width < 400) {
            this.setState({
                chartConfig: {
                    ...this.state.chartConfig,
                    chart: {...this.state.chartConfig.chart, height: 1300},
                    title: {...this.state.chartConfig.title, text: this.props.fullCountryReport == true ? '' : `<h2 class='title--card'>${tabTitle}</h2>`}
                }
            });
        }        
	}

    componentDidMount() {
        this.getLoadData(this.props.chartType);

        if (this.props.chartType.length > 1) {
            this.setState({ typeCharts: this.props.chartType.map((chart) => chart.type) });
        }

        this.updateDimension();
        window.addEventListener('resize', this.updateDimension);
    }

    componentDidUpdate(prevProps, prevState) {
      
        if(prevProps.selectedDataset != this.props.selectedDataset){
            this.setState({ selectedDataset: this.props.selectedDataset });
        }

        if(this.props.selectedIndicator){
            if(this.props.selectedIndicator != this.state.selectedTypeChart){
                this.setState({selectedTypeChart: this.props.selectedIndicator})
            }
        }

        if(prevState.selectedDataset != this.state.selectedDataset || prevProps.selectedSortBy != this.props.selectedSortBy
            || prevProps.selectedIndicator != this.props.selectedIndicator || prevState.selectedTypeChart != this.state.selectedTypeChart || prevState.sortByAnswer != this.state.sortByAnswer){
            this.getLoadData(this.props.chartType);
        }

        if (prevProps.chartType != this.props.chartType || prevProps.country != this.props.country)
        {
            this.getLoadData(this.props.chartType);
            this.updateDimension();
        }

        if (prevProps.type != this.props.type) {
            this.setState({ chartConfig: {...this.state.chartConfig, chart: {...this.state.chartConfig.chart, type: this.props.type} } })
        }

        if(prevProps.selectedIndicator != this.props.selectedIndicator || prevProps.tabIndicator != this.props.tabIndicator){
            let chart;
            if (this.props.chartType)
            {
                chart = this.props.chartType.find((chart) => chart.type == this.props.selectedIndicator);
            }
            else
            {
                chart = this.props.chartType.find((chart) => chart.type == this.props.tabIndicator);
            }
            if (chart != undefined)
            {
                this.setState({
                    sortByAnswer: chart.sortByAnswer
                })
            }            
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimension);
    }

	handleDatasetChange = (dataset, indicator) => {
		this.setState({
			selectedDataset: dataset
		})
	}
    
    render() {

        let selectDiv;
        let selectDatasetDiv;
        let selectSortByOptions;
		
		if(this.props.showSelect){

            if(this.props.temporalShow == true){
                let selectOptions = this.props.chartType.map((chart) => chart.type);
                selectDiv = (
                    <div className="select-filter-chart-wrapper">
                        {selectOptions.length > 1 && (
                            <div className="select-filter-chart">
                                <select onChange={this.onChangeSelect} value={this.state.selectedTypeChart} >
                                    {selectOptions.map((type) => {
                                        return <option key={type} value={type} > {type.toUpperCase()} </option>
                                    })}
                                </select>
                            </div>
                        )}
                    </div>
                )
            }            

            if(this.props.showDatasetSelect){
                selectDatasetDiv = (
                    <div className='select--dataset--chart'>
                        <SelectDataset
                            chart={this.props.chartType[0].chart}
                            indicator={this.props.chartType[0].chartIndicator}
                            esener={'true'}
                            handleDatasetChange={(e) => this.handleDatasetChange(e, this.props.chartType[0].chartIndicator)}
                            handleDefaultDataset={this.handleDefaultDataset}
                        />
                    </div>
                )
            }
        }

        return (
            <React.Fragment>
                    <div className='chart--filters--block'>
                        {selectDiv}
                        {selectSortByOptions}
                        {selectDatasetDiv}
                    </div>
                    {!this.state.isLoading && (
                        <div className='chart-container'>
                            <HighchartsReact
                                highcharts={Highcharts}
                                options={this.state.chartConfig}
                                containerProps={{ className: 'chartContainer' }}
                            />
                        </div>
                    )}
            </React.Fragment>
        );
    }
}

export default MentalRiskCharts;